// Formata um número em reais como dinheiro: 10 → "R$ 10,00".
export function formatarReais(v: number): string {
  return v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

// Número com 4 dígitos: 6 → "0006".
export function pad4(n: number): string {
  return String(n).padStart(4, '0');
}

// "20/12"
export function formatarData(iso: string | null | undefined): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const dia = String(d.getDate()).padStart(2, '0');
  const mes = String(d.getMonth() + 1).padStart(2, '0');
  return `${dia}/${mes}`;
}

// "20/12 às 20h"
export function formatarDataHora(iso: string | null | undefined): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const dia = String(d.getDate()).padStart(2, '0');
  const mes = String(d.getMonth() + 1).padStart(2, '0');
  const hora = String(d.getHours()).padStart(2, '0');
  return `${dia}/${mes} às ${hora}h`;
}

interface InfoSorteio {
  sorteio_em: string | null;
  sorteio_por: string | null;
  sorteio_onde: string | null;
}

// "Resultado 20/12 às 20h, ao vivo no Instagram @perfil" etc.
export function fraseSorteio(t: InfoSorteio): string {
  const dataHora = formatarDataHora(t.sorteio_em);
  const onde = t.sorteio_onde ? t.sorteio_onde.trim() : '';
  if (t.sorteio_por === 'instagram') {
    return `Resultado ${dataHora}, ao vivo no Instagram${onde ? ` @${onde.replace(/^@/, '')}` : ''}`;
  }
  if (t.sorteio_por === 'facebook') {
    return `Resultado ${dataHora}, ao vivo no Facebook${onde ? ` ${onde}` : ''}`;
  }
  return `Resultado ${formatarData(t.sorteio_em)} pela Loteria Federal`;
}

// Lista os prêmios: "1º Um boi · 2º Uma bicicleta".
export function listaPremios(
  premios: { ordem: number; descricao: string }[] | null | undefined,
): string {
  if (!premios || premios.length === 0) return '';
  return premios.map((p) => `${p.ordem}º ${p.descricao}`).join(' · ');
}

// "0006, 0007, 0008"
export function listaNumerosVirgula(numeros: number[]): string {
  return numeros.map((n) => pad4(n)).join(', ');
}

export function formatarCentavos(centavos: number): string {
  const reais = Math.floor(centavos / 100);
  const cents = centavos % 100;
  return `R$ ${reais.toLocaleString('pt-BR')},${String(cents).padStart(2, '0')}`;
}

// Total da conta para exibir (usa a linha em destaque; senão o total do banco).
export function totalDaConta(
  detalhe: { linha: string; valor: string; destaque: boolean }[] | undefined,
  totalReais: string | number | undefined,
): string | null {
  const destaque = detalhe?.find((l) => l.destaque);
  if (destaque?.valor) return destaque.valor;
  if (totalReais == null) return null;
  const n = typeof totalReais === 'number' ? totalReais : Number(totalReais);
  if (!Number.isFinite(n)) return null;
  return formatarReais(n);
}

// Conta prévia da oferta (só para exibir): taxa = ceil(subtotal × 7%), quando
// a taxa não está "por dentro".
export interface ContaOferta {
  subtotalCentavos: number;
  taxaCentavos: number;
  totalCentavos: number;
  mostrarTaxa: boolean;
}

export function calcularContaOferta(
  valorCota: number,
  quantidade: number,
  taxaPorDentro: boolean,
): ContaOferta {
  const subtotalCentavos = Math.round(valorCota * 100) * quantidade;
  const taxaCentavos = taxaPorDentro ? 0 : Math.ceil(subtotalCentavos * 0.07);
  return {
    subtotalCentavos,
    taxaCentavos,
    totalCentavos: subtotalCentavos + taxaCentavos,
    mostrarTaxa: !taxaPorDentro,
  };
}